export default __webpack_public_path__ + "globe.853575f4c01c0241f32f987716e6e868.svg";